"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formWasClosed = exports.formWasSubmitted = exports.setFormAsSubmitted = exports.setFormAsClosed = void 0;
var STATE_CLOSED = "0";
var STATE_SUBMITTED = "1";

var sessionStorageAvailable = function sessionStorageAvailable() {
  return typeof sessionStorage !== 'undefined';
};

var formWasSubmitted = function formWasSubmitted(locationId) {
  var state = null;

  if (sessionStorageAvailable()) {
    state = sessionStorage.getItem("emailcapture-".concat(locationId));
  }

  return state === STATE_SUBMITTED;
};

exports.formWasSubmitted = formWasSubmitted;

var setFormAsClosed = function setFormAsClosed(locationId) {
  if (sessionStorageAvailable() && !formWasSubmitted(locationId)) {
    sessionStorage.setItem("emailcapture-".concat(locationId), STATE_CLOSED);
  }
};

exports.setFormAsClosed = setFormAsClosed;

var setFormAsSubmitted = function setFormAsSubmitted(locationId) {
  if (sessionStorageAvailable()) {
    sessionStorage.setItem("emailcapture-".concat(locationId), STATE_SUBMITTED);
  }
};

exports.setFormAsSubmitted = setFormAsSubmitted;

var formWasClosed = function formWasClosed(locationId) {
  var state = null;

  if (sessionStorageAvailable()) {
    state = sessionStorage.getItem("emailcapture-".concat(locationId));
  }

  return state === STATE_CLOSED;
};

exports.formWasClosed = formWasClosed;